import React from 'react';

const labels = {
  tr: 'Şefin Önerisi',
  en: "Chef's Pick",
  me: 'Preporuka Šefa',
  ru: 'Выбор Шеф-повара',
  sr: 'Препорука Шефа'
};

/**
 * Lüks altın gradient şerit — müşteri menü kartlarının üst sol köşesine yerleşir.
 * size: 'sm' (kompakt) | 'md' (default).
 */
const ChefPickBadge = ({ language = 'tr', size = 'md' }) => {
  const label = labels[language] || labels.en;
  const sizes = {
    sm: 'text-[9px] px-2 py-0.5',
    md: 'text-[10px] px-2.5 py-1'
  };
  return (
    <div
      data-testid="chef-pick-badge"
      className={`${sizes[size]} bg-gradient-to-r from-amber-500 via-amber-400 to-yellow-500 text-charcoal font-bold rounded-full shadow-lg shadow-amber-500/30 ring-1 ring-amber-300/50 flex items-center gap-1 uppercase tracking-wider whitespace-nowrap`}
    >
      <span className="text-[11px] leading-none">⭐</span>
      <span>{label}</span>
    </div>
  );
};

export default ChefPickBadge;
